import Question from "./question.js"
import MultipleChoiceQuestionComponent from "../components/questions/multiple-choice-question.jsx"
import MultipleChoicePreviewComponent from "../components/previews/multiple-choice-preview.jsx";
import MultipleChoiceReportComponent from "../components/reports/multiple-choice-report.jsx";
class MultipleChoiceQuestion extends Question {
  component(mode) {
    switch (mode) {
      case "student-facing-report":
        return MultipleChoiceReportComponent;
      case "preview":
        return MultipleChoicePreviewComponent;
      default:
        return MultipleChoiceQuestionComponent;
    }
  }

  hasChoiceContentForTts() {
    return true
  }
}

export default MultipleChoiceQuestion